module.exports = __webpack_public_path__ + "assets/tenbisFlyCard-9300e2.svg";